import React, { Component } from "react";
import { Button, Modal, Select, Descriptions, Input  } from "antd";
import { deletedCode } from "../../lib/util/codeUtil";
import SelectBox from "../common/SelectBox";
import { httpUrl, httpPost, httpGet } from "../../api/httpClient";

const Ditems = Descriptions.Item;
class ModifyNotice extends Component{
  state = {  
    selectedData:{},
    title:this.props.data.title,
    content:this.props.data.content
      
      
  }; 

  onCancel = () => {
    this.props.onCancel();
  };

  componentDidMount() {}


  render() {
    const { visible, data, onClose} = this.props;
    
    return (
      <Modal
        visible={visible}
        title={"수정하기"} 

        onOk={()=>{            
          httpPost(httpUrl.noticeUpdate, [], {
            idx: data.idx,
            title: this.state.title,
            content:this.state.content
          }).then((res) =>{            
            Modal.info({
              title: "수정완료",
              content: "수정이 완료 되었습니다."
          })
            onClose()
          })        
        }}
        onCancel={this.props.onClose}        
        okText={"수정"}
        cancelText="취소"
        style={{ minWidth: "800px"}}
      >
        <Descriptions
          bordered
          column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}
        >          
          <Ditems label="제목" span={2} labelStyle={{textAlign: "center"}}>
            <Input
              placeholder="제목을 입력 해주세요"
              rows={2}
              value={this.state.title}
              onChange={(e) => {
                this.setState({
                  title: e.target.value });
                }}
              style={{ width: "100%" }}
            />&nbsp;
          </Ditems>
          <Ditems label="내용" span={2} labelStyle={{textAlign: "center"}}>
            <Input.TextArea
              placeholder="내용을 입력 해주세요"
              rows={10}              
              value={this.state.content}
              onChange={(e) => {

                // this.onChangeModal(e.target.value, "answer");
                this.setState({                     
                    content: e.target.value });
              }}
              style={{ width: "100%" }}
            />&nbsp;        
          </Ditems>         
        </Descriptions>
      </Modal>
    );
  }
}
   


export default ModifyNotice;